import { FC } from 'react';

import { Reactions } from '../../reactions';

export const DetectorEmotionClient: FC<{
  sendEmotionsSelect?: (result: { category: string[]; emo: string[] }) => void;
  /** Мобильный 1:1 на весь экран */
  mobile?: boolean;
}> = ({ sendEmotionsSelect, mobile = false }) => {
  return (
    <div className={mobile ? 'h-full w-full' : 'min-w-[250px] w-full md:w-[30vw] lg:w-[15vw] h-full'}>
      <Reactions sendEmotionsSelect={sendEmotionsSelect} mobile={mobile} />
    </div>
  );
};
